'use client';

import { c as _c } from "react/compiler-runtime";
import SvgChevronright from '@common/__generated__/icon/SvgChevronright';
import { FOCUS_RING } from '@common/components/interaction';
import { cn } from '@core/utils';
import { useState } from 'react';
import { Image } from '@/components/client';
import { RegionFinderDialog } from './RegionFinderDialog';
export const RegionFinderBanner = t0 => {
  const $ = _c(13);
  const {
    className
  } = t0;
  const [isDialogOpened, setIsDialogOpened] = useState(false);
  let t1;
  if ($[0] !== className) {
    t1 = cn("w-full px-20", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("flex w-full items-center justify-center gap-40 rounded-xxlarge bg-O-25 px-8 py-16 max-[359px]:gap-16", "transition-opacity duration-200 ease-out active:opacity-80 xl:hover:opacity-80", FOCUS_RING);
    t3 = () => setIsDialogOpened(true);
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Image src="https://cdn.welfarehello.com/static/donation-home-region-banner-v2.png" alt="" width={144} height={144} className="size-48 shrink-0 object-contain" loading="lazy" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="flex items-center gap-16">{t4}<span className="flex flex-col font-600 text-O-500 typo-body4"><span>지역의 답례품을 찾아보고</span><span>관심 있는 곳에 기부하세요.</span></span></span>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <button aria-label={"\uC9C0\uC5ED \uCC3E\uAE30 \uC5F4\uAE30"} className={t2} onClick={t3}>{t5}<span className="flex size-28 shrink-0 items-center justify-center rounded-pill bg-Gray-white/50"><SvgChevronright className="size-16 text-O-500" /></span></button>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setIsDialogOpened(false);
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== isDialogOpened) {
    t8 = <RegionFinderDialog opened={isDialogOpened} onClose={t7} />;
    $[8] = isDialogOpened;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t1 || $[11] !== t8) {
    t9 = <article className={t1}>{t6}{t8}</article>;
    $[10] = t1;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
};